export default __webpack_public_path__ + "static/media/qris1.68a02a2f.png";